import { MyTenantsResult, TenantManagementApi } from "breuer-supercharged-sdk";
import { getClient } from "./client";

export class TenantService {
    private static instance: TenantService;

    private constructor() { }

    public static getInstance(): TenantService {
        if (!TenantService.instance) {
            TenantService.instance = new TenantService();
        }
        return TenantService.instance;
    }

    private client = new TenantManagementApi(undefined, undefined, getClient())

    async getMyTenants(): Promise<MyTenantsResult[]> {
        const response = await this.client.findAllTenantsForUser();
        return response.data;
    }
}